import * as React from 'react';

interface IState {
    hasError: boolean;
}

// React Error Boundary component. Wrap it around any other react components
// to catch script errors in any child component.
class ErrorWrapper extends React.Component<{}, IState> {
    constructor(props: null) {
        super(props);
        this.state = { hasError: false };
    }

    public componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({
            hasError: true,
        });

        if (info != null && info.componentStack != null) {
            error.stack = info.componentStack;
        }

        console.log(`Oops we ran into an error - ${error}`);
    }

    public render() {
        if (this.state.hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default ErrorWrapper;
